import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=72c5dff8"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"
import style0 from "./Signup.vue?vue&type=style&index=0&id=72c5dff8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72c5dff8')) {
      api.createRecord('72c5dff8', component.options)
    } else {
      api.reload('72c5dff8', component.options)
    }
    module.hot.accept("./Signup.vue?vue&type=template&id=72c5dff8", function () {
      api.rerender('72c5dff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/signup/Signup.vue"
export default component.exports